<template>
  <section class="history">
    <div class="container">
      <div class="section-title">
        <h2>Latest Transaction History</h2>
      </div>
    </div>
    <div class="table">
      <table v-if="records.length > 0">
        <tr>
          <th>Client</th>
          <th>Topup Number</th>
          <th>Type</th>
          <th>Operator</th>
          <th>Amount</th>
          <th>Payment Method</th>
          <th>Transaction ID</th>
          <th>Transaction Date</th>
        </tr>
        <tr v-for="(record,index) in records" :key="index">
          <td>{{ record.client_email }}</td>
          <td>{{ record.topup_mobile }}</td>
          <td>{{ record.connection_type }}</td>
          <td>{{ record.operator }}</td>
          <td>{{ record.amount }}</td>
          <td>{{ record.payment_method }}</td>
          <td>{{ record.txn_id }}</td>
          <td>{{ record.receive_date }}</td>
        </tr>
      </table>
      <table v-else>
        <tr>
          <td colspan="8" style="text-align: center;color:#696970;">No Transaction Available!</td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "TopupHistoryTable",
  data() {
    return {
      records: []
    }
  },
  created() {
    this.getData();
  },
  computed: {
    getUser() {
      console.log("Computed")
      return this.$store.state.authUser
    }
  },
  methods: {
    getData() {
      let instance = this;
      axios.get(`${this.apiPath}client/topup-history/${localStorage.getItem('email')}`)
          .then(function (response) {
            instance.records = response.data.data;
          }).catch(function (error) {

      });
    }
  }
}
</script>

<style scoped>
.history {
  margin-top: 50px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

table td, table th {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 8px;
  color: #2c2d2e;
}

table td:nth-child(3), td:nth-child(4), td:nth-child(6) {
  text-transform: capitalize;
}

table tr {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}

table tr:nth-child(even) {
  background-color: rgba(240, 242, 245, 0.45);
}

table tr:hover {
  background-color: rgba(143, 45, 86, 0.32);
}

.table {
  padding: 0 120px;
}

table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #8F2D56;
  color: #ffffff;
  font-weight: 500
}
</style>